import {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react';
import { Flex, Avatar } from '@chakra-ui/react';
import { TruncatedTextWithTooltip } from '@/ui/TooltipText';

export const MentionList = forwardRef((props, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const itemRefs = useRef([]);

  const selectItem = (index) => {
    const item = props.items[index];

    if (item) {
      props.command({ id: `${item?.uuid}:${item?.id}`, label: item?.name });
    }
  };

  const upHandler = () => {
    setSelectedIndex(
      (selectedIndex + props.items.length - 1) % props.items.length
    );
  };

  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % props.items.length);
  };

  const enterHandler = () => {
    selectItem(selectedIndex);
  };

  useEffect(() => setSelectedIndex(0), [props.items]);

  useEffect(() => {
    if (itemRefs.current[selectedIndex]) {
      itemRefs?.current[selectedIndex]?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [selectedIndex]);

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === 'ArrowUp') {
        upHandler();
        return true;
      }

      if (event.key === 'ArrowDown') {
        downHandler();
        return true;
      }

      if (event.key === 'Enter') {
        enterHandler();
        return true;
      }

      return false;
    },
  }));

  return (
    <Flex
      p="6px"
      flexDir="column"
      postion="relative"
      boxShadow="0px 4px 6px -2px #10182808, 0px 12px 16px -4px #10182814"
      border="1px solid"
      borderColor="border-color"
      borderRadius="sm"
      background="#fff"
      maxH="200px"
      overflowY="auto"
    >
      {props.items.length ? (
        props.items.map((item, index) => (
          <Flex
            key={index}
            onClick={() => selectItem(index)}
            cursor="pointer"
            p="10px"
            bg={index === selectedIndex ? 'ats-tertiary' : ''}
            alignItems="center"
            gap="8px"
            borderRadius="6px"
            className="avatar-sm "
            ref={(el) => (itemRefs.current[index] = el)}
          >
            <Avatar w="20px" h="20px" src={item?.avatar} name={item?.name} />
            <TruncatedTextWithTooltip fontSize="sm" text={item?.name} />
          </Flex>
        ))
      ) : (
        <div className="item">No result</div>
      )}
    </Flex>
  );
});
